import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Mail, MapPin } from "lucide-react";

export const ContactSection = () => {
  const { t, language } = useLanguage();

  const contactInfo = {
    en: {
      subtitle: "Get in touch",
      location: "Laurentians Region, Quebec, Canada",
      availability: "Available worldwide — remote or on-site",
      email: "contact@eyatech.ca",
    },
    fr: {
      subtitle: "Nous joindre",
      location: "Région des Laurentides, Québec, Canada",
      availability: "Disponible partout dans le monde — à distance ou sur site",
      email: "contact@eyatech.ca",
    },
  };

  const info = contactInfo[language];

  return (
    <section
      id="contact"
      className="relative min-h-screen flex flex-col justify-start overflow-hidden pt-28 md:pt-32 pb-16 md:pb-20 px-4 md:px-8"
    >
      <div className="max-w-4xl mx-auto w-full">
        {/* Main Title */}
        <div className="mb-10 md:mb-16 pb-6 border-b border-[#2a2a2a]">
          <h2
            className="
              uppercase text-[#d8d8d8] opacity-50 font-bold
              text-5xl md:text-7xl
              tracking-[0.12em] md:tracking-[0.25em]
              whitespace-normal break-words
            "
            style={{ fontFamily: "var(--font-eurostile)" }}
          >
            {t("contact")}
          </h2>
        </div>

        {/* Contact Content */}
        <div className="relative pl-5 md:pl-8 py-8 bg-gradient-to-r from-[#121416]/40 to-transparent border-l border-[#2a2a2a]">
          <h3
            className="
              text-[#d8d8d8] opacity-50 font-bold uppercase
              text-2xl md:text-[28px]
              tracking-[0.10em] md:tracking-wide
              mb-8
              whitespace-normal break-words
            "
            style={{ fontFamily: "var(--font-eurostile)" }}
          >
            {info.subtitle}
          </h3>

          <div className="h-[1px] w-24 bg-[#5a6e54] mb-10 opacity-40"></div>

          <div className="space-y-8">
            {/* Location */}
            <div className="flex items-start">
              <MapPin
                size={24}
                className="text-[#5a6e54] mr-4 flex-shrink-0 mt-1"
              />
              <div>
                <p
                  className="text-[#d8d8d8] mb-2"
                  style={{
                    fontFamily: "var(--font-eurostile)",
                    fontSize: "21px",
                    lineHeight: "1.6",
                    fontWeight: "400",
                  }}
                >
                  {info.location}
                </p>
                <p
                  className="text-[#888]"
                  style={{
                    fontFamily: "var(--font-eurostile)",
                    fontSize: "18px",
                    lineHeight: "1.6",
                    fontWeight: "400",
                  }}
                >
                  {info.availability}
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-center">
              <Mail size={24} className="text-[#5a6e54] mr-4 flex-shrink-0" />
              <a
                href={`mailto:${info.email}`}
                className="text-[#d8d8d8] hover:text-[#5a6e54] transition-colors break-all"
                style={{
                  fontFamily: "var(--font-eurostile)",
                  fontSize: "21px",
                  lineHeight: "1.6",
                  fontWeight: "400",
                }}
              >
                {info.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
